const SPECIAL_PROTOCOLS = ['tel:', 'mailto:', 'viber:'];
const SAFE_PROTOCOLS = ['http:', 'https:', 'tel:', 'mailto:', 'viber:'];

const parseUrl = url => {
    try {
        if (!url || typeof url !== 'string') return null;

        const normalized = url.trim();

        if (normalized.startsWith('//')) return null;

        const isSpecial = SPECIAL_PROTOCOLS.some(p => normalized.toLowerCase().startsWith(p));

        if (isSpecial) {
            return {
                href: normalized,
                protocol: normalized.split(':')[0] + ':',
                pathname: '',
                search: '',
                hash: '',
                origin: null,
                special: true
            };
        }

        const parsed = new URL(normalized, window.location.origin);

        if (!SAFE_PROTOCOLS.includes(parsed.protocol)) return null;

        return parsed;
    } catch {
        return null;
    }
};

const resolveUrl = url => {
    const parsed = parseUrl(url);

    if (!parsed) {
        return {
            parsed: null,
            safe: false,
            external: false,
            isSpecial: false
        };
    }

    if (parsed.special) {
        return {
            parsed,
            safe: true,
            external: false,
            isSpecial: true
        };
    }

    const isStaticFile =
        parsed.pathname.startsWith('/static/') ||
        /\.(pdf|doc|docx|xls|xlsx)$/i.test(parsed.pathname);

    const isExternalOrigin =
        parsed.protocol.startsWith('http') && parsed.origin !== window.location.origin;

    return {
        parsed,
        safe: SAFE_PROTOCOLS.includes(parsed.protocol),
        external: isExternalOrigin || isStaticFile,
        isSpecial: false
    };
};

const isNonSpaResource = parsed => {
    if (!parsed) return true;

    const path = parsed.pathname;

    const isBackend = path.startsWith('/api/') || path.startsWith('/backend/');

    const isAsset =
        path.startsWith('/static/') ||
        path.startsWith('/media/') ||
        path.startsWith('/files/') ||
        path.startsWith('/uploads/');

    const isFile = /\.(pdf|doc|docx|xls|xlsx|zip|rar|jpg|jpeg|png|gif|svg|webp)$/i.test(path);

    return isBackend || isAsset || isFile;
};

export const getSafeLinkProps = (url, options = {}) => {
    const {target: forcedTarget, navigate} = options;

    const {parsed, safe, external, isSpecial} = resolveUrl(url);

    const isBlank = forcedTarget === '_blank';

    if (!safe || !parsed) {
        return {
            href: '#',
            onClick: e => {
                e.preventDefault();
                return false;
            }
        };
    }

    if (isSpecial) {
        return {
            href: parsed.href
        };
    }

    const internalPath = parsed.pathname + parsed.search + parsed.hash;

    const shouldUseSpa = !external && !isNonSpaResource(parsed) && !!navigate && !isBlank;

    if (shouldUseSpa) {
        return {
            href: internalPath,
            onClick: e => navigate(internalPath, e)
        };
    }

    const finalBlank = isBlank || external;

    return {
        href: external ? parsed.href : internalPath,
        target: finalBlank ? '_blank' : undefined,
        rel: finalBlank ? 'noopener noreferrer' : undefined
    };
};
